function autoResize(el) {
  el.style.height = 'auto';
  el.style.height = `${el.scrollHeight}px`;
}

/**
 * ダウンロードするWordファイル（復命書）の見た目を画面上で近似したもの。
 * fukumeishoExport.jsのbuildFukumeishoWordBlobと同じ項目に合わせてある。
 * 承認印欄（施設長／総務部長／部署責任者）は枠だけ示し、中身の編集は無し。
 * 項目・本文はここで直接編集でき、onFieldChange/onBodyChangeで親のstateに反映される。
 */
export default function FukumeishoPreview({ fields, onFieldChange, bodyText, onBodyChange }) {
  return (
    <div className="word-preview-page">
      <h3 className="wp-title">復　命　書</h3>
      <table className="wp-stamp-table">
        <thead>
          <tr><th>施設長</th><th>総務部長</th><th>部署責任者</th></tr>
        </thead>
        <tbody>
          <tr><td></td><td></td><td></td></tr>
        </tbody>
      </table>

      <table className="wp-info-table">
        <tbody>
          <tr>
            <th>研修名</th>
            <td><input className="wp-field wp-field-cell" value={fields.trainingName} onChange={(e) => onFieldChange('trainingName', e.target.value)} /></td>
            <th>提出日</th>
            <td><input className="wp-field wp-field-cell" value={fields.submitDate} onChange={(e) => onFieldChange('submitDate', e.target.value)} /></td>
          </tr>
          <tr>
            <th>研修場所</th>
            <td><input className="wp-field wp-field-cell" value={fields.trainingPlace} onChange={(e) => onFieldChange('trainingPlace', e.target.value)} /></td>
            <th>職種</th>
            <td><input className="wp-field wp-field-cell" value={fields.jobType} onChange={(e) => onFieldChange('jobType', e.target.value)} /></td>
          </tr>
          <tr>
            <th>日時</th>
            <td><input className="wp-field wp-field-cell" value={fields.datetime} onChange={(e) => onFieldChange('datetime', e.target.value)} /></td>
            <th>氏名</th>
            <td><input className="wp-field wp-field-cell" value={fields.name} onChange={(e) => onFieldChange('name', e.target.value)} /></td>
          </tr>
        </tbody>
      </table>

      <div className="wp-item">
        <textarea
          className="wp-item-textarea wp-fukumeisho-body"
          value={bodyText}
          placeholder="本文がここに表示されます"
          ref={(el) => { if (el) autoResize(el); }}
          onChange={(e) => { onBodyChange(e.target.value); autoResize(e.target); }}
        />
      </div>
    </div>
  );
}
